import { ENV } from '@/lib/config/env';
import {
  GuidelineResponseDto,
  GuidelineCreateDto,
  GuidelineUpdateDto,
  GuidelineListDto,
  FolderDto,
  FolderCreateDto,
  FolderUpdateDto,
  FolderWithGuidelinesDto,
  client as guidelinesClient,
} from '@inference.engine/guidelines-api-client/web';

import { configureApiClient } from './configure-client';

if (!ENV.GUIDELINES_API_BASE_URL) {
  throw new Error('GUIDELINES_API_BASE_URL environment variable is not set');
}

export const guidelinesHttp = configureApiClient(guidelinesClient, ENV.GUIDELINES_API_BASE_URL);
export type {
  GuidelineResponseDto,
  GuidelineCreateDto,
  GuidelineUpdateDto,
  GuidelineListDto,
  FolderDto,
  FolderCreateDto,
  FolderUpdateDto,
  FolderWithGuidelinesDto,
};
